import {Component, ComponentRef} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {tap} from 'rxjs/operators';

import {GenericFieldDirective} from '../../directives/generic-field/generic-field.directive';
import {DynamicFormElement, DynamicFormElementEl} from '../../interfaces/fields-components';
import {
  CustomFieldData,
  CustomFieldDynamicData,
  FormAllInsertData,
  translatedString,
} from './../../interfaces/forms/form-element';
import {Observable} from 'rxjs';
import {DynamicComponentBaseComponent} from '../../../dynamic-components/components/dynamic-component-base/dynamic-component-base.component';
import {DynamicComponentObject} from '../../../dynamic-components/interfaces/dynamic-component-object';

@Component({
    selector: 'app-custom-component',
    templateUrl: './custom-component.component.html',
    styleUrls: ['./custom-component.component.scss'],
    standalone: false
})
export class CustomFieldComponent extends GenericFieldDirective {
  dynamicComponent!: DynamicComponentObject<CustomFieldDynamicData<CustomFieldData>>;

  ComponentRef!: ComponentRef<DynamicComponentBaseComponent>;

  control!: AbstractControl | null;
  errorOptions!: {
    hideErrorBox: boolean;
    customErrorLabel?: Record<string, translatedString>;
  };

  override initData({
    field,
    formGroup,
  }: DynamicFormElementEl<CustomFieldDynamicData<CustomFieldData<CustomFieldData>>>): void {
    if (field?.dynamicComponent) {
      this.dynamicComponent = field.dynamicComponent;
      this.dynamicComponent.data =
        this.dynamicComponent.data ?? <CustomFieldDynamicData<CustomFieldData>>{};

      const keys = Object.keys(field) as (keyof CustomFieldData<
        CustomFieldDynamicData<FormAllInsertData>
      >)[];
      keys.forEach((el) => {
        if (el && el !== 'dynamicComponent') {
          (<unknown>this.dynamicComponent.data[el]) = field[el];
        }
      });

      this.dynamicComponent.data.formGroup = formGroup;
      if (this.dynamicComponent.data.name) {
        this.control =
          this.dynamicComponent.data.formGroup.get(this.dynamicComponent.data.name ?? '') ?? null;
        this.errorOptions = {
          hideErrorBox: this.dynamicComponent.data['hideErrorBox'] ?? false,
          customErrorLabel: this.dynamicComponent.data['customErrorLabel'],
        };
      }
    }
  }
  override setUpdateListener() {
    const id = this.field?.name ?? this.field?.id;
    const formgroup: FormGroup =
      (this.formGroup?.parent?.get(this.stepName) as FormGroup) ?? this.formGroup;

    if (id) {
      this.getSubjectObservable?.unsubscribe();
      this.getSubjectObservable = (<Observable<CustomFieldData>>this.callListener(id, formgroup))
        .pipe(
          tap((el: CustomFieldData) => {
            if (el?.dynamicComponent?.data && this.ComponentRef) {
              this.ComponentRef.instance.data = {
                ...this.dynamicComponent.data,
                ...el.dynamicComponent.data,
              };
            }
          }),
        )
        .subscribe();
    }
  }

  onCreatedComponent(customComponent: ComponentRef<DynamicComponentBaseComponent>) {
    this.ComponentRef = customComponent;
  }
}
